export const TEXT_REGEX = /[0-9!@#$%^&*(),.?":{}|<>]/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!%*?&])[A-Za-z\d@$#!%*?&]{8,}$/;
export const PHONE_REGEX = /^[0-9]{10}$/;
// export const NAME_REGEX = /[^a-zA-Z\s'-]/;
export const NAME_REGEX = /[^a-zA-Z\s'.-]/;
export const DECIMAL_REGEX = /^\d*(\.\d{0,2})?$/;
export const WHOLE_NUMBER_REGEX = /^\d+$/;

export const validateName = (value, name) => {
  if (value === "") return `${name} is required.`;
  if (NAME_REGEX.test(value))
    return `${name} can only contain letters, spaces, hyphens, and apostrophes.`;
  if (value.trim() !== value)
    return `${name} cannot have leading or trailing spaces.`;
  if (value.length < 1) return `${name} must be at least 3 characters long.`;
  if (value.length > 50) return `${name} cannot exceed 50 characters.`;
  return "";
};

export const validateTextArea = (value, name) => {
  if (value === "") return `${name} field is required.`;
  if (value.length > 2000) return `${name} cannot exceed 2000 characters.`;
  return "";
};

export const validateEmail = (value) => {
  if (value === "") return "Email address is required.";
  else if (!value.match(EMAIL_REGEX))
    return "Please enter a valid email address.";
  else if (value.length > 100) return "Email cannot exceed 100 characters.";
  return "";
};

export const validateUsername = (value) => {
  if (!value || value.trim() === "") {
    return "Username is required.";
  }
  return "";
};

const areAllDigitsIdentical = (value) => {

  if (value.length === 1) return false;
  return value.split("").every((digit) => digit === value[0]);
};

const areDigitsSequential = (value) => {
  const sequential = ["0123456789", "9876543210", "1234567890"];
  return sequential.includes(value);
};

export const requiredFieldValidation = (value, name) => {
  if (value === "") return `${name} is required.`;
  return "";
};

export const requiredFieldValidation2 = (value, name) => {
  if (value?.length === 0) return `${name} is required.`;
  return "";
};

export const validatePhone = (value, expectedLength, countryLabel) => {
  value = value.replace(/\D/g, '');
  if (areAllDigitsIdentical(value) && value.trim() !== "")
    return "Phone number cannot have all identical digits.";

  if (areDigitsSequential(value) && value.trim() !== "")
    return "Phone number cannot have sequential digits.";

  const phoneLength = value.replace(/\D/g, "").length;
  const allowedLengths = Array.isArray(expectedLength)
    ? expectedLength
    : [expectedLength];

  if (!allowedLengths.includes(phoneLength) && value.trim() !== "") {
    return `Phone number must be ${allowedLengths.join(
      " or "
    )} digits for ${countryLabel}.`;
  }

  return "";
};

export const validatePassword = (value) => {
  if (value === "") return `Password is required.`;
  if (value.length > 32) return "Password cannot exceed 32 characters.";
  if (!value.match(PASSWORD_REGEX))
    return "Password must meet the required criteria.";
  return "";
};

export const validateFeild = (value, name) => {
  if (value === "") return `${name} is required.`;
  if (value.length < 3) return `${name} must be at least 3 characters long.`;
  if (value.length > 500) return `${name} cannot exceed 100 characters.`;
  return "";
};

export const validateAddress = (value, name) => {
  if (value === "") return `${name} is required.`;
  if (value.trim() !== value)
    return `${name} cannot have leading or trailing spaces.`;
  return "";
};

export const validateZipCode = (value) => {
  if (value === "") return `Zip code is required.`;
  if (value.length < 3) return "Zip code must be at least 3 characters long.";
  if (value.length > 6) return "Zip code cannot exceed 6 characters";
  return "";
};

export const validateDecimalNumber = (value, name) => {
  if (value === "") return `${name} is required.`;
  if (!DECIMAL_REGEX.test(value))
    return "Please enter value upto two decimal number.";
  if (Number(value) < 0) return `${name} must be greater than 0`;
  if (Number(value) > 100) return `${name} must be less than 100`;
  return "";
};

export const validateTokenPrice = (value, name) => {
  if (value === "") return `${name} is required.`;
  if (!DECIMAL_REGEX.test(value))
    return "Please enter value upto two decimal number.";
  if (Number(value) < 0) return `${name} must be greater than 0`;
  return "";
};

export const validateNumber = (value, name) => {
  if (value === "") return `${name} is required.`;
  if (!WHOLE_NUMBER_REGEX.test(value))
    return "Please enter valid number without decimal.";
  if (Number(value) < 0) return `${name} must be greater than 0`;
  return "";
};

export const getPasswordValidationErrors = (password) => {
  return {
    length: password.length >= 8 && password.length <= 32,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    specialChar: /[\W_]/.test(password),
    number: /\d/.test(password),
  };
};

export const validateChange = (name, value) => {
  switch (name) {
    case "name":
      return validateName(value, "Name");
    case "fullName":
      return validateName(value, "Name");
    case "email":
      return validateEmail(value);
    case "emailId":
      return validateEmail(value);
    case "phonenumber":
      return validatePhone(value);
    case "password":
      return validatePassword(value);
    case "companyName":
      return validateName(value, "Company name");
    case "pbtname":
      return validateName(value, "PBT name");
    case "propertyname":
      return validateName(value, "Property name");
    case "tokenprice":
      return validateTokenPrice(value, "Token price");
    case "projectedreturn":
      return validateDecimalNumber(value, "Projected return");
    case "yearlyreturn":
      return validateDecimalNumber(value, "Yearly return");
    case "occupationrate":
      return validateDecimalNumber(value, "Occupation rate");
    case "availabletoken":
      return validateNumber(value, "Available token");
    case "propertyvalue":
      return validateNumber(value, "Property value");
    case "docname":
      return validateName(value, "Document name");
    case "address":
      return validateAddress(value, "Address");
    case "employmentAddress":
      return validateAddress(value, "Address");
    case "city":
      return validateAddress(value, "City");
    case "state":
      return validateAddress(value, "state");
    case "country":
      return validateAddress(value, "Country");
    case "zipcode":
      return validateZipCode(value);
    case "zipCode":
      return validateZipCode(value);
    case "objective":
      return validateTextArea(value, "Objective");
    case "valueproposition":
      return validateTextArea(value, "Value proposition");
    case "managementapproach":
      return validateTextArea(value, "Management approach");
    case "yearsInRealEstate":
      return validateNumber(value, "Years");
    case "areasOfExpertise":
      return validateFeild(value, "Area of experties");
    case "currentBrokerage":
      return validateName(value, "Current Brokaerage");
    case "companyAge":
      return validateNumber(value, "Company age");
    case "annualRevenue":
      return validateNumber(value, "Annual Revenue");
    case "activePropertiesManaged":
      return validateNumber(value, "Active properties");
    case "soldProperties":
      return validateNumber(value, "Solid properties");
    case "assetsUnderManagement":
      return validateNumber(value, "Asset under management");
    case "uploadResume":
      return requiredFieldValidation(value, "Upload resume");
    case "auditedFinancials":
      return requiredFieldValidation2(value, "Audited financials");
    case "workStatus":
      return requiredFieldValidation(value, "Work status");
    case "sourceOfIncome":
      return requiredFieldValidation(value, "Source of income");
    case "employmentName":
      return validateName(value, "Employment name");
    case "industry":
      return requiredFieldValidation(value, "Industry");
    case "role":
      return validateName(value, "role");
    default:
      return; // You can handle any default behavior here if needed
  }
};

export const validateDateSpan = (fromDate, toDate) => {
  if (!fromDate || !toDate) return "Please select both Start and End Dates";
  const from = new Date(fromDate);
  const to = new Date(toDate);
  if (isNaN(from.getTime()) || isNaN(to.getTime()))
    return "Invalid date format";
  if (to < from) return "End date cannot be earlier than start date";
  return "";
};
